export const layout = {
  sidebar: {
    appName: 'Referent',
    toggleSidebar: 'Toggle sidebar',
    currentOrganization: 'Current Organization',
    openSergeo: 'Open Sergeo',
    orgSwitcher: {
      label: 'Switch organization',
      noOrganization: 'No organization selected',
      switchError: 'Could not switch organization',
    },
  },
  sidebarNav: {
    overview: 'Overview',
    overviewSummary: 'Dashboard',
    overviewAiTraffic: 'Traffic from AI',
    overviewDeliverables: 'Deliverables',
    collaborators: 'Collaborators',
    main: 'Main',
    content: 'Content',
    research: 'Audits',
    tools: 'Tools',
    dashboard: 'Dashboard',
    brandVoices: 'Brand Voices',
    contentGenerator: 'Content Generator',
    newContent: 'New Content',
    myContents: 'My Contents',
    bulkGeneration: 'Bulk Generation',
    geoAuditor: 'GEO Auditor',
    organization: 'Organization',
    companySettings: 'Company Settings',
    logout: 'Log out',
    settings: 'Settings',
    support: 'Support',
    superAdmin: 'Super-Admin Dashboard',
    superAdminDeliverables: 'Deliverables (Super-Admin)',
    contentPlan: 'Content Plan',
    keywordResearch: 'Keyword Research',
    competitiveAnalysis: 'Competitive Analysis',
    keywordGap: 'Keyword Gap',
    keywordPositioning: 'Keyword Positioning',
    data: 'AI Visibility',
    dataDashboard: 'Overview',
    dataPrompts: 'Prompts',
    dataPromptsList: 'All prompts',
    dataResponses: 'Responses',
    dataSources: 'Sources',
    dataActions: 'Actions',
    aiKeywordExpansion: 'AI Keyword Expansion',
    seoAudit: '360 Audit',
    prospectAudits: 'Prospect Audits',
    landingPages: 'Landing Pages',
    socialAnalytics: 'LinkedIn Metrics',
    contentOptimization: 'Optimizer',
    nativeContent: 'Content Engine',
    knowledgeBase: 'Knowledge Base',
    trendFilter: 'Trend Filter',
    sergeo: 'Sergeo',
    integrations: 'Integrations',
    seo: 'SEO',
    seoSummary: 'Summary',
    seoDetails: 'SEO Details',
    aiVisibility: 'AI Visibility',
    aiVisibilityAiTraffic: 'AI Traffic',
    aiVisibilityShareOfVoice: 'Share of Voice',
    aiVisibilityPrompts: 'Prompts',
    workspace: 'Workspace',
    workspaceDeliverables: 'Deliverables',
  },
  language: {
    english: 'English',
    selectLanguage: 'Select Language',
    spanish: 'Español',
  },
  dashboard: {
    welcome: 'Welcome',
    welcomeBack: 'Welcome back, {{name}}',
    welcomeMessage: 'Manage your SEO and GEO projects efficiently',
    overview: "Here's what's happening with your SEO and GEO campaigns today.",
    quickActions: 'Quick Actions',
    metrics: {
      activeCampaigns: {
        title: 'Active Campaigns',
        description: 'Your current running campaigns',
        value: '12',
        delta: '+2 from last month',
      },
      totalReach: {
        title: 'Total Reach',
        description: 'Impressions this month',
        value: '45.2K',
        delta: '+18% from last month',
      },
      conversionRate: {
        title: 'Conversion Rate',
        description: 'Average across all campaigns',
        value: '3.2%',
        delta: '+0.5% from last month',
      },
    },
    stats: {
      activeProjects: 'Active Projects',
      recentActivity: 'Recent Activity',
      performance: 'Performance',
      descriptions: {
        activeProjects: 'Active projects this month',
        recentActivity: 'Recent activity count',
        performance: 'Overall performance',
      },
      comparisons: {
        projectsIncrease: '+18% from last month',
        activityIncrease: '+5% from last week',
        performanceStatus: 'On track',
      },
    },
    actions: {
      manageOrganization: 'Manage Organization',
      viewSettings: 'Settings',
    },
    recentActivity: {
      title: 'Recent Activity',
      description: 'Your latest updates and changes',
      newProjectCreated: 'New project created',
      dashboardUpdated: 'Dashboard updated',
      entries: {
        summerSale: {
          title: 'Summer Sale Campaign launched',
          time: '2 hours ago',
        },
        keywordUpdate: {
          title: 'New keyword rankings updated',
          time: '5 hours ago',
        },
        weeklyReport: {
          title: 'Weekly report generated',
          time: '1 day ago',
        },
      },
      timeAgo: {
        hoursAgo: '{{count}} hours ago',
        daysAgo: '{{count}} day ago',
        daysAgoPlural: '{{count}} days ago',
      },
    },
    memberCount: {
      singular: 'member',
      plural: 'members',
    },
  },
} as const
